import { useState, useEffect } from "react";
import styled from "styled-components";
import DateFormatUtil from "../../helpers/DateFormatUtil";
import Breakpoints from "../../config/Breakpoints";
import SectionTitle from "./sectionTitle";
import RaffleTab from "./raffleTab";

const RaffleDataContainer = styled.div`
    display: flex;
    gap: 1rem;
    margin: 2.5rem auto 0;
    max-width: 55rem;
    justify-content: center;
    transition: all ease .4s;

    @media ${Breakpoints.max.sm} {
        margin-top: 2rem;
        flex-wrap: wrap;
    }
`;

const RaffleDataCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    text-align: center;
    border-radius: .5rem;
    border: 1px solid var(--color-lightGray);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
    background: var(--color-white);
    padding: 1rem 1.25rem;
    width: 13rem;
    box-sizing: border-box;
    transition: all ease .4s;

    & > span {
        color: var(--color-gray);
        line-height: 1.2em;
        font-size: var(--font-size-sm);
    }
    
    & > strong {
        font-size: var(--font-size-xl);
    }

    @media ${Breakpoints.max.sm} {
        width: auto;
        flex-basis: 45%;
        flex: 1;
    }

    @media ${Breakpoints.max.xs} {
        & > strong {
            font-size: var(--font-size-lg);
        }
    }
`;

const RaffleCalendar = ({sectionData, promoData}) => {
    const [currentRaffleData, setCurrentRaffleData] = useState({});

    useEffect(() => {
        promoData.raffles.forEach((item, index) => {
            if(item.isNextRaffle) {
                console.log(item);
                setCurrentRaffleData(item);
                return;
            }
        });
    },[promoData]);

    const setCurrentTab = (newValue) => {
        setCurrentRaffleData(promoData.raffles[newValue]);
    };
    return (
        <>
            <SectionTitle>{sectionData.title}</SectionTitle>
            <div>
                <RaffleTab promoData={promoData} handleChange={setCurrentTab} />
                <RaffleDataContainer>
                    {(currentRaffleData.participateStartDate || currentRaffleData.participateEndDate) && (
                        <RaffleDataCard>
                            <span>Período de<br/> participação</span>
                            <strong>
                                {currentRaffleData.participateStartDate && !currentRaffleData.participateEndDate && <>A partir de {DateFormatUtil(currentRaffleData.participateStartDate)}</>}
                                {!currentRaffleData.participateStartDate && currentRaffleData.participateEndDate && <>Até {DateFormatUtil(currentRaffleData.participateEndDate)}</>}
                                {currentRaffleData.participateStartDate && currentRaffleData.participateEndDate && <>{DateFormatUtil(currentRaffleData.participateStartDate)} a {DateFormatUtil(currentRaffleData.participateEndDate)}</>}
                            </strong>
                        </RaffleDataCard>
                    )}
                    {currentRaffleData.evaluateEndDate && (
                        <RaffleDataCard>
                            <span>Divulgação dos<br/> números da sorte</span>
                            <strong>Até {DateFormatUtil(currentRaffleData.evaluateEndDate)}</strong>
                        </RaffleDataCard>
                    )}
                    {currentRaffleData.raffleDate && (
                        <RaffleDataCard>
                            <span>Sorteio</span>
                            <strong>{DateFormatUtil(currentRaffleData.raffleDate)}</strong>
                        </RaffleDataCard>
                    )}
                    {currentRaffleData.winnersPublishDate && (
                        <RaffleDataCard>
                            <span>Divulgação dos<br/> ganhadores a partir de</span>
                            <strong>{DateFormatUtil(currentRaffleData.winnersPublishDate)}</strong>
                        </RaffleDataCard>
                    )}
                </RaffleDataContainer>
            </div>
        </>
    );
}

export const RaffleCalendarStyles = `
    
`;

export default RaffleCalendar;